<template>
  <div class="row">
    <div class="col-md-6">
      <div class="row">
        <label class="col-form-label col-md-4"
          >{{ $t('homework.teacher') }} :</label
        >
        <div class="col-md-8 text-left">
          <p class="mt-2">{{ info.teacher_name }}</p>
        </div>
      </div>
      <div class="row">
        <label class="col-form-label col-md-4"
          >{{ $t('homework.date') }} :</label
        >
        <div class="col-md-8 text-left">
          <p class="mt-2">{{ info.homework_date }}</p>
        </div>
      </div>
      <div class="row">
        <label class="col-form-label col-md-4"
          >{{ $t('homework.subject') }} :</label
        >
        <div class="col-md-8 text-left">
          <p class="mt-2">{{ info.subject_name }}</p>
        </div>
      </div>
      <div class="row">
        <label class="col-form-label col-md-4"
          >{{ $t('homework.class') }} :</label
        >
        <div class="col-md-8 text-left">
          <p class="mt-2">{{ info.class_name }}</p>
        </div>
      </div>
      <div class="row">
        <label class="col-form-label col-md-4"
          >{{ $t('homework.submissionEnddate') }} :</label
        >
        <div class="col-md-8 text-left">
          <p class="mt-2">{{ info.submission_end_date }}</p>
        </div>
      </div>
      <div class="row">
        <label class="col-form-label col-md-4"
          >{{ $t('homework.remark') }} :</label
        >
        <div class="col-md-8 text-left">
          <p class="mt-2">{{ info.remarks }}</p>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="row form-group">
        <div class="col-md-12">
          <span class="badge badge-info">{{
            $t('homework.homeworkfile')
          }}</span>
          <div class="ts-p-3">
            <ul>
              <li
                v-for="(homework, index) in homeworkFile"
                :key="index"
                class="ts-float-left ts-px-2"
              >
                <a
                  href="#"
                  v-tooltip="homework.attach_file_name"
                  @click.prevent="onDownload(homework)"
                >
                  <a-icon
                    type="file"
                    :style="{ fontSize: '16px', color: '#08c' }"
                    :spin="homework.action"
                  />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-md-12">
          <span class="badge badge-info">{{
            $t('homework.referenceFile')
          }}</span>
          <div class="ts-p-3">
            <ul>
              <li
                v-for="(reference, index) in referenceFile"
                :key="index"
                class="ts-float-left ts-px-2"
              >
                <a
                  href="#"
                  v-tooltip="reference.attach_file_name"
                  @click.prevent="onDownload(reference)"
                >
                  <a-icon
                    type="file"
                    :style="{ fontSize: '16px', color: '#08c' }"
                    :spin="reference.action"
                  />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as FileDownload from 'downloadjs'

export default {
  name: 'homeworkInfoCorrection',
  props: ['info'],
  data() {
    return {}
  },
  computed: {
    homeworkFile() {
      if (_.isEmpty(this.info)) return []

      return this.info.homework_attachment.filter(
        att => att.attach_file_type == 1
      )
    },
    referenceFile() {
      if (_.isEmpty(this.info)) return []

      return this.info.homework_attachment.filter(
        att => att.attach_file_type == 2
      )
    }
  },
  methods: {
    onDownload(record) {
      record.action = true
      this.$store
        .dispatch('eschool/homeworkCorrection/download', {
          filePath: record.attach_file_path
        })
        .then(response => {
          FileDownload(
            response,
            record.attach_file_name,
            record.attach_file_mime_type
          )
        })
        .catch(error => {
          let parese_error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(error))
          )
          this.$toasted.error(parese_error.message)
        })
        .finally(() => {
          record.action = false
        })
    }
  }
}
</script>
